import { render, staticRenderFns } from "./r-firefly-v2-page.vue?vue&type=template&id=8e3e5610"
import script from "./r-firefly-v2-page.vue?vue&type=script&lang=js"
export * from "./r-firefly-v2-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3e5610')) {
      api.createRecord('8e3e5610', component.options)
    } else {
      api.reload('8e3e5610', component.options)
    }
    module.hot.accept("./r-firefly-v2-page.vue?vue&type=template&id=8e3e5610", function () {
      api.rerender('8e3e5610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/firefly/r-firefly-v2-page.vue"
export default component.exports